import moment from "moment"
import { FC } from "react"

import styles from "../styles/Card.module.scss"

interface RecordCardProps {
  item: any
  onClick: (ev: any) => void
  onTipsAction: () => void
}

const RecordCard: FC<RecordCardProps> = ({
  item, onClick, onTipsAction
}) => {

  const isOrderEnded = (item: any) => {
    if (item != null) {
      if (item.order.reviews.length > 0) {
        return false
      }

      let orderStart = moment(item.result.data.datetime).unix() + item.result.data.seance_length
      let now = moment().unix()
      if (now > orderStart) {
        return true
      }
    }

    return false
  }

  return (
    <>
      <div className={styles.record_card} style={{opacity: item.order.reviews.length > 0 ? "0.5" : "1", borderColor: item.order.reviews.length > 0 ? "rgba(255,255,255,.2)" : "#fff"}} onClick={onClick}>
        <div className={styles.rc_top}>
          <div className={styles.record_card__data}>
            <div>{item.company.data.title}</div>
            <div>{item.company.data.address}</div>
            <div>{moment(item.result.data.datetime).format("DD MMMM, HH:mm")}</div>
          </div>
          <div className={styles.record_card__arrow}><i className="fas fa-chevron-right"></i></div>
        </div>
        {isOrderEnded(item) ? <div className={styles.rc_bottom}>
          <button onClick={() => onTipsAction()}>Оставить отзыв и чаевые</button>
        </div> : <></>}
      </div>
    </>
  )
}

export default RecordCard